<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.03 89.55">
    <g id="Calque_2" data-name="Calque 2">
      <g id="ƒŒƒCƒ_1" data-name="ƒŒƒCƒ„[ 1">
        <path
          class="cls-1"
          d="M79,89.55H2a2,2,0,0,1-2-2v-77a2,2,0,0,1,2-2H8.66V2a2,2,0,0,1,2-2H70.34a2,2,0,0,1,2,2V8.52H79a2,2,0,0,1,2,2v77A2,2,0,0,1,79,89.55ZM4.06,85.49H77V12.58H70.34a2,2,0,0,1-2-2V4.06H12.72v6.49a2,2,0,0,1-2,2H4.06Z"
        />
        <path
          class="cls-1"
          d="M50.17,89.16H30.86A1.36,1.36,0,0,1,29.5,87.8V65.08a1.35,1.35,0,0,1,1.36-1.35H50.17a1.34,1.34,0,0,1,1.35,1.35V87.8A1.35,1.35,0,0,1,50.17,89.16Zm-18-2.71H48.82v-20H32.21Z"
        />
        <path
          class="cls-1"
          d="M40.51,88.1a1.36,1.36,0,0,1-1.35-1.36V66.58a1.36,1.36,0,1,1,2.71,0V86.74A1.36,1.36,0,0,1,40.51,88.1Z"
        />
        <rect class="cls-2" x="13.25" y="23.05" width="11.08" height="11.08" />
        <path
          class="cls-1"
          d="M24.32,35.48H13.25a1.35,1.35,0,0,1-1.35-1.36V23.05a1.35,1.35,0,0,1,1.35-1.36H24.32a1.36,1.36,0,0,1,1.36,1.36V34.12A1.36,1.36,0,0,1,24.32,35.48ZM14.6,32.77H23V24.4H14.6Z"
        />
        <rect class="cls-2" x="34.98" y="23.05" width="11.08" height="11.08" />
        <path
          class="cls-1"
          d="M46.05,35.48H35a1.36,1.36,0,0,1-1.36-1.36V23.05A1.36,1.36,0,0,1,35,21.69H46.05a1.36,1.36,0,0,1,1.36,1.36V34.12A1.36,1.36,0,0,1,46.05,35.48Zm-9.72-2.71H44.7V24.4H36.33Z"
        />
        <rect class="cls-2" x="56.7" y="23.05" width="11.08" height="11.08" />
        <path
          class="cls-1"
          d="M67.78,35.48H56.7a1.36,1.36,0,0,1-1.35-1.36V23.05a1.36,1.36,0,0,1,1.35-1.36H67.78a1.35,1.35,0,0,1,1.35,1.36V34.12A1.35,1.35,0,0,1,67.78,35.48Zm-9.72-2.71h8.37V24.4H58.06Z"
        />
        <rect class="cls-2" x="13.25" y="43.5" width="11.08" height="11.08" />
        <path
          class="cls-1"
          d="M24.32,55.93H13.25a1.35,1.35,0,0,1-1.35-1.36V43.5a1.35,1.35,0,0,1,1.35-1.36H24.32a1.36,1.36,0,0,1,1.36,1.36V54.57A1.36,1.36,0,0,1,24.32,55.93ZM14.6,53.22H23V44.85H14.6Z"
        />
        <rect class="cls-2" x="34.98" y="43.5" width="11.08" height="11.08" />
        <path
          class="cls-1"
          d="M46.05,55.93H35a1.36,1.36,0,0,1-1.36-1.36V43.5A1.36,1.36,0,0,1,35,42.14H46.05a1.36,1.36,0,0,1,1.36,1.36V54.57A1.36,1.36,0,0,1,46.05,55.93Zm-9.72-2.71H44.7V44.85H36.33Z"
        />
        <rect class="cls-2" x="56.7" y="43.5" width="11.08" height="11.08" />
        <path
          class="cls-1"
          d="M67.78,55.93H56.7a1.36,1.36,0,0,1-1.35-1.36V43.5a1.36,1.36,0,0,1,1.35-1.36H67.78a1.35,1.35,0,0,1,1.35,1.36V54.57A1.35,1.35,0,0,1,67.78,55.93Zm-9.72-2.71h8.37V44.85H58.06Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconEnterprise',
};
</script>
<style scoped>
.cls-1 {
  fill: #162b46;
}
.cls-2 {
  fill: #f9802f;
}
</style>
